/**
 * useOpenInNebula
 *
 * Shared "open this artifact in Nebula view" action, used by every diagram
 * viewer (Mermaid, Html, Markmap, Physics, React). Was previously duplicated
 * verbatim in all 5 files:
 *
 *   const openInNebula = () => {
 *     const p = new URLSearchParams(window.location.search);
 *     p.set('mode', 'nebula');
 *     navigate('?' + p.toString());
 *   };
 *
 * Centralizing it means a fix (e.g. the missing `{ replace: true }` — see
 * below) only needs to happen once instead of being kept in sync across 5
 * near-identical copies.
 *
 * replace: true — mirrors Header.jsx's toggleNebulaMode. Entering/exiting
 * Nebula is a UI mode toggle, not a page navigation; without `replace`, every
 * "Open in Nebula" click pushed a new browser history entry, so a single
 * Back-button press after a few toggles just replayed old mode=nebula/no-mode
 * states instead of leaving the chat.
 *
 * @returns {() => void} openInNebula — call to switch the current view into Nebula mode
 */
import { useNavigate } from "react-router-dom";

export function useOpenInNebula() {
  const navigate = useNavigate();

  const openInNebula = () => {
    const p = new URLSearchParams(window.location.search);
    p.set("mode", "nebula");
    navigate("?" + p.toString(), { replace: true });
  };

  return openInNebula;
}

export default useOpenInNebula;
